import LoadingCircle from '../components/LoadingCircle'
import moment from 'moment-timezone';
import MemberAddonManager from '../billing/MemberAddonManager';

export default class PlanTeam {

    constructor() {
        this.focusOutModeratorField = true

        this.addTeamMateField       = $('#team-mate-email-field')
        this.addTeamMateContainer   = $('#invite-team-mate-container')

        this.addTeamMateBtn         = $('#add-team-mate-btn')

        this.modal=$("#add-team-mate-modal");
        this.avatarIcon=`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
            <path d="M256,0c-74.439,0-135,60.561-135,135s60.561,135,135,135s135-60.561,135-135S330.439,0,256,0z" fill="#000000" data-original="#000000" class=""></path>
            <path d="M423.966,358.195C387.006,320.667,338.009,300,286,300h-60c-52.008,0-101.006,20.667-137.966,58.195    C51.255,395.539,31,444.833,31,497c0,8.284,6.716,15,15,15h420c8.284,0,15-6.716,15-15    C481,444.833,460.745,395.539,423.966,358.195z" fill="#000000" data-original="#000000" class=""></path>
        </svg>`;

        //email input
        this.memberEmailInput=$("#team-member-email-input");
        this.memberEmailActions=$("#member-email-input-actions");
        this.memberEmailError=$("#team-member-email-error");
        this.membersList=$("#team-member-invites-list");
        this.showManageMembersButton=$("#add-team-mate-modal-btn");

        this.membersObject=[];
        this.availableAddons=false;

        this.events()
        this.onLoad()
    }



    events() {
        const team=this;
        // this.addTeamMateField.on('input paste change', e => $('#add-team-mate-modal .modal-body .other-error').html(''))
        this.addTeamMateBtn.on('click', e => this.store(e))
        this.showManageMembersButton.on('click',team.showManageAddonsModal.bind(team));
        $('#team-members-table tbody').on('click', '[data-action="delete"]', e => this.destroy(e))
        $('#confirm-remove-team-mate').on('click', e => this.confirmRemove(e))

        this.modal.on('hidden.bs.modal', e => {
            this.onModalHidden();
        })

        // $('#team-mate-email-field').on('keypress', e => this.addTeamMateKeyPressHandler(e))

        // $('#team-mate-email-field').on('focus', e => {
        //     this.focusInModeratorField = true
        //     this.focusOutModeratorField = false
        //     $('#invite-team-mate-container').addClass('focused')
        // })
        // $('#team-mate-email-field').on('focusout', e => this.addTeamMateFocusOutHandler(e))

        // $('#invite-team-mate-container').on('click', '.remove-icon', e => this.removeTeamMemberFromListHandler(e))
        this.initMembersEmailInput();
    }

    onModalHidden(){
        this.membersObject=[];
        this.memberEmailInput.val('');
        this.showEmptyInvites();
    }
    
    showManageAddonsModal(){
        this.modal.modal('show');
        this.memberEmailInput.trigger('focus');
        this.loadCurrentMembers();
    };


    loadCurrentMembers(){
        this.ownerEmail='';
        this.getMembers().then(data=>{
            data.members.reverse().forEach(member=>{
                if(member.id < 0){
                    this.ownerEmail=member.member_email; 
                }
                this.addInvitee(member.member_email,this.availableAddons.filter(a=>member.addons.includes(a.id))).then(invitee=>{
                    this.appendInviteeToList(invitee);
                });
            })
        })
    }

    initMembersEmailInput(){
        if(this.membersObject.length==0){
            this.showEmptyInvites();
        }
        const actionAdd=$("<button/>",{
            class:"mui-action d-none",
            html:`<i class="fa fa-check" aria-hidden="true"></i>`,
            title:"Add Team Member"
        }).on('click',()=>{
                let item = this.memberEmailInput.val()
                if(!this.validateEmail(item)){
                    this.setMemberEmailError("Invalid email address")
                    return false
                } 
                if(!item.length) return false;
                this.addInvitee(item).then(invitee=>{
                    this.memberEmailInput.val("");
                    this.memberEmailInput.trigger("change");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setMemberEmailError(err)
                })
            this.memberEmailInput.trigger("focus")
        });

        const actionClear=$("<button/>",{
            class:"mui-action d-none",
            html:`<i class="fa fa-times" aria-hidden="true"></i>`,
            title:"Clear"
        }).on('click',()=>{
            this.memberEmailInput.val("");
            this.memberEmailInput.trigger("change");
            this.memberEmailInput.trigger("focus")
        });

        this.memberEmailActions.html([actionAdd,actionClear])
        this.memberEmailInput.on('keypress', e => {
            
            let KeyID = e.keyCode;
            if(KeyID == 13 || KeyID == 32 || KeyID == 44) {
                e.preventDefault()
                let item = this.memberEmailInput.val()
                if(!this.validateEmail(item)){
                    this.setMemberEmailError("Invalid email address")
                    return false
                } 
                if(!item.length) return false;
                this.addInvitee(item).then(invitee=>{
                    this.memberEmailInput.val("");
                    this.memberEmailInput.trigger("change");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setMemberEmailError(err)
                })
            }else{
                this.setMemberEmailError("")
            }
        }).on('focus', e => {
            
        }).on('focusout',e=>{
            
        }).on('input paste change',()=>{
            let item = this.memberEmailInput.val()
            this.setMemberEmailError('')
             if(!item.length){
                actionClear.addClass('d-none');
                actionAdd.addClass('d-none')
             }else{
                actionClear.removeClass('d-none');
                if(this.validateEmail(item)){
                    actionAdd.removeClass('d-none');
                }else{
                    actionAdd.addClass('d-none')
                }
             }
        });
    }

    addInvitee(email,addons=[]){
        return new Promise((resolve,reject)=>{
            const exists=this.membersObject.find(invitee=>invitee.email==email);
            if(exists){
                reject("Member already added")
                return
            }

            const invitee={
                email:email,
                addons:addons
            };
            if(this.membersObject){
                this.hideEmptyInvites();
            }
            this.setError('')
            this.membersObject.push(invitee);
            resolve(invitee);

        });
    };

    removeInvitee(email){
        return new Promise((resolve,reject)=>{
            this.membersObject=this.membersObject.filter(invitee=>invitee.email != email);
            console.log("Members array",this.membersObject);
            if(!this.membersObject.length){
                this.showEmptyInvites();
            }
            this.setError('');
            resolve();
        });
    };

    updateInviteeAddons(email,addons){
        return new Promise((resolve,reject)=>{
            const invitee=this.membersObject.find(invitee=>invitee.email == email);
            if(invitee){
                invitee.addons=addons;
            } 
            this.setError('')
            resolve();
        })
    };

    getMemberAddons(email){
        let addons=[];
        const invitee=this.membersObject.find(invitee=>invitee.email == email);
        if(invitee){
            addons=invitee.addons.map(a=>a.id);
        } 
        return addons;
    }

    appendInviteeToList(invitee){
        const item=$("<li/>",{
            class:"mui-list-item"
        });
        const avatar=$("<div/>",{
            class: "mui-avatar",
            html: this.avatarIcon
        });
        const emailLabel=$("<label/>",{
            class: "mui-font-weight-500 mb-0",
            html: invitee.email
        });
        const roleLabel=$("<span/>",{
            class: "mui--text-caption",
            html: invitee.addons.length ? invitee.addons.map(a=>a.name).join(", ") : "No Add-ons"
        })

        const removeBtn=$("<button/>",{
            class:"mui-action",
            html: `<i class="fa fa-times" aria-hidden="true"></i>`,
            title:"Remove Member"
        }).on('click',()=>{
            this.removeInvitee(invitee.email).then(()=>{
                item.remove();
            })
        });
        const ManageAddonsButton=$("<button/>",{
            class:`mui-action`,
            html: `<i class="fa fa-th-large" aria-hidden="true"></i>`,
            title:"Add Add-ons"
        }).on('click',()=>{
           let manager=new MemberAddonManager(this.getPurchasedQty(),this.getInUseQty());
           manager.withAddons(this.availableAddons,this.getMemberAddons(invitee.email))
           .showManager(invitee.email).then(selectedAddons=>{
                roleLabel.html(selectedAddons.length ? selectedAddons.map(a=>a.name).join(", ") : "No Add-ons")
                this.updateInviteeAddons(invitee.email,selectedAddons);
                console.log("selected addons for member "+invitee.email,selectedAddons);
                manager=undefined;
           }).catch(e=>{
                manager=undefined;
           })
        });

        const title=$("<div/>",{
            class:"mui-item-title d-flex flex-column",
            html:[emailLabel,roleLabel]
        });
        const actions=$("<div/>",{
            class:"mui-item-actions",
            html:[ManageAddonsButton,invitee.email != this.ownerEmail ? removeBtn : '']
        });

        item.html([avatar,title,actions]);


        this.membersList.prepend(item);
    };


    showEmptyInvites(){
        this.membersList.html(`<li class="mui-list-item invites-empty-placeholder">
            <div class="mui-empty-invites">
                <img src="/images/email/inviteEmail.png" alt="">
            </div>
        </li>`);
    };

    hideEmptyInvites(){
        this.membersList.find('.invites-empty-placeholder').remove();
    };

    setMemberEmailError(error){
        this.memberEmailError.html(error);
    };

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

 

    removeTeamMemberFromListHandler(e) {
        let elem = $(e.target).closest('.user-container')
        $('#team-mate-email-field').removeClass('d-none')
        // if(elem.prev().length) {
        //     if(elem.prev().hasClass('list-separator')) {
        //         elem.prev().remove()
        //     } else if(elem.prev().prev().hasClass('list-separator')) {
        //         elem.prev().prev().remove()
        //     }

        // } else if(elem.next().length) {
        //     if(elem.next().hasClass('list-separator')) elem.next().remove()
        // }

        elem.remove()
        $('#submit_schedule').attr('disabled', false)
    }



    onLoad() {
        this.index()
        this.getAvailableAddons();
    }

    getAvailableAddons(){
        axios.get('/profile/billing/addons').then(response=>{
            console.log("got available addons",response.data)
            if(response.data.available){
                this.availableAddons=response.data.available;
            }
            if(response.data.addons){
                this.purchasedAddons=response.data.addons;
            }
        }).catch(err=>{
            console.error(err);
        })
    };

    getInUseQty(){
        const inUse={};
        this.membersObject.forEach(member=>{
            for (let index = 0; index < member.addons.length; index++) {
                const addon = member.addons[index];
                if(inUse[addon.id]){
                    inUse[addon.id]++;
                }else{
                    inUse[addon.id]=1;
                }
            }
        })

        return inUse;
    }
    getInUseQtyFromPurchased(){
        const inUse={};
        if(this.purchasedAddons){
            this.purchasedAddons.forEach(paddon=>{
                inUse[paddon.id]=parseInt(paddon.in_use);
            })
        }

        return inUse;
    }
    getPurchasedQty(){
        const purchased={};
        if(this.purchasedAddons){
            this.purchasedAddons.forEach(paddon=>{
                purchased[paddon.id]=parseInt(paddon.qty);
            })
        }
        return purchased;
    }
    index() {
        $(`#team-members-table tbody`).html('')
        this.getMembers().then(data => {
            const addonNames=data.addons;
            data.members.forEach(el => {
                const userAddons=addonNames.filter(a=>el.addons.includes(a.id));
                const addonLabels=userAddons.map(a=>{return `<span class="badge bg-secondary text-white px-2">${a.name}</span>`}).join(" ");
                const manageAddonsBtn=$("<button/>",{
                    class:"mui-btn mui-btn--small mui-btn--gray mui-btn--fab",
                    html:`<i class="fa fa-th-large" aria-hidden="true"></i>`,
                    title:"Add-ons"
                }).on('click',()=>{
                    let manager=new MemberAddonManager(this.getPurchasedQty(),this.getInUseQtyFromPurchased());

                    manager.withAddons(this.availableAddons,el.addons)
                    .showManager(el.member_email,false).then(selectedAddons=>{
                         
                        //  this.updateInviteeAddons(invitee.email,selectedAddons);
                         console.log("selected addons for member "+el.member_email,selectedAddons);
                         this.updateMemberAddons({
                            email:el.member_email,
                            member_id:el.id,
                            addons:selectedAddons.map(a=>a.id)
                         }).then(res=>{
                            if(!res.data.error){
                                this.onLoad();
                            }
                         }).finally(res=>{
                            manager.closeManager();
                            manager=undefined;
                            // this.onLoad()
                        });
                    }).catch(e=>{
                        console.error(e)
                         manager=undefined;
                    })
                 });
                const actions=$("<div/>",{
                    class:"d-flex justify-content-end",
                    html:[manageAddonsBtn]
                })
    
                const td=$("<td/>",{
                    class:"vertical-align-middle",
                    html:actions
                })

                const row=$("<tr/>",{
                        html:[`<td class="vertical-align-middle">${el.name}</td>`,
                        `<td class="vertical-align-middle">${el.member_email}</td>`,
                        `<td class="vertical-align-middle">${addonLabels}</td>`,
                        `<td class="vertical-align-middle" nowrap>${el.role=="member" ? moment(el.created_at).format('MMM DD, YYYY') : ''}</td>`,
                        `<td class="vertical-align-middle"><span class="badge bg-${(el.accepted) ? 'success' : 'secondary'} text-white px-2">${(el.accepted) ? "accepted" : 'pending'}</span></td>`,
                        td]
                        });
                $(`#team-members-table tbody`).append(row)
            });

        }).catch(err => {
        })
    }

    getMembers(){
        return new Promise((resolve,reject)=>{
            axios.get(`/plan-member`).then(res=>{
                resolve(res.data);
            }).catch(err=>{
                resolve([]);
            });

        })
    };
    setError(error){
        $("#team_members_response_error").html(error);
    }
    store(e) {
        e.preventDefault()
        let loading_circle = new LoadingCircle()
        // $('#add-team-mate-modal .modal-header button.close').addClass('invisible')
        loading_circle.buttonShow($(e.currentTarget))
        this.setError('')
        const teamMembers=[];
        this.membersObject.forEach(member=>{
            teamMembers.push({
                email: member.email,
                addons: member.addons.map(a=>a.id)
            });
        });
        axios.put(`/profile/billing/team-members`, {
            team: teamMembers
        }).then(res => {
            console.log("add members response",res.data)
            if(res.data.error){
                this.setError(res.data.message);
            }else{
                this.onLoad();
                this.modal.modal('hide');
            }
        }).catch(err => {
            console.log("add members error",err.response.data);
            if(err.response.data) {
                this.setError("Something went wrong.")
            }
        }).finally(() => {
            setTimeout(() => {
                loading_circle.buttonHide($(e.currentTarget))
                // $('#add-team-mate-modal .modal-header button.close').addClass('invisible')
            }, 500);
        })
    
    }

    updateMemberAddons(body){
        return axios.put(`/profile/billing/team-members/member/addons`, body);
    };

    destroy(e) {
        e.preventDefault()
        this.memberId = $(e.currentTarget).closest('tr').data('id')
        $('#remove-team-mate-modal').modal();
    }

    confirmRemove(e) {
        if(!this.memberId) {
            return false;
        }

        let loading_circle = new LoadingCircle()
        loading_circle.buttonShow($(e.currentTarget))
        // $('#remove-team-mate-modal .modal-header button.close').addClass('invisible')
        $('#cancel-remove-team-mate').addClass('invisible')

        axios.post(`/plan-member/${this.memberId}`, {
            _method: "delete"
        }).then(res => {
            $(`#team-members-table tbody tr[data-id="${this.memberId}"]`).remove();
        }).catch(err => {

        }).finally( () => {
            $('#remove-team-mate-modal').modal('hide');
            setTimeout(() => {
                loading_circle.buttonHide($(e.currentTarget))
                // $('#remove-team-mate-modal .modal-header button.close').removeClass('invisible')
                $('#cancel-remove-team-mate').removeClass('invisible')
            }, 500);
        })
    }

}
